
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import scroll from '@/mixins/scroll'
import { ShopGoodsInfoDto, PartnerCategoryList } from '@/api/industryMall'
import { getPcGoodsCategoryList, batchUpdatePackage, getStoreLevelManageList, modifyGoodsPriceSubmit } from '@/api/goodsModule'
import { batchHandleGoods } from '@/api/ccx'
import { getGoodsFileList, getGoodsFileCategory } from '@/api/ccxIntegratedService'
import SelectGoodsCard from '@/views/jielong/components/SelectGoodsCard.vue'

const PRESELECTED_GOODS_CACHE_KEY = 'jielongPreselectedGoods'

Component.registerHooks(['beforeRouteLeave'])
@Component({
  name: 'SelectGoods',
  components: {
    SelectGoodsCard
  }
})
export default class SelectGoods extends Mixins(scroll) {
  @Prop({ default: 1 }) flag!: number // 1 已上架 2：已下架
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  // @Getter topSafetyHeight!: number

  selectedGoods: ShopGoodsInfoDto[] = []
  /** 已在接龙商品列表中、不可取消勾选的 goodsId */
  disabledGoodsIds: string[] = []
  searchValue = '' // 商品名称搜索输入态
  /** 已生效的前端搜索关键字（回车/清空时同步；切换分类不清空） */
  appliedKeyword = ''
  params = {
    hierarchyId: '',
    companyId:''
  }
  refreshing = false
  loading = false
  finished = false
  // 一级分类
  active1Key = 0
  // 二级分类
  active2Key = 0
  // 三级分类
  active3Key = 0
  tabActive = 0
  tabs: PartnerCategoryList[] = []
  category: PartnerCategoryList = {}
  goodsList: ShopGoodsInfoDto[] = []
  category3List: PartnerCategoryList[] = []
  show = false
  contentOverlayShow = false
  packageIdList: Array<string> = [] // 选择的套餐id集合
  levelList: Array<any> = []
  specsValue = 1
  checkAll = false
  checkAllValue = false

  get newlySelectedCount (): number {
    return this.selectedGoods.filter(g => !this.disabledGoodsIds.includes(g.goodsId)).length
  }

  /** 当前最小分类下商品，按已生效关键字做前端名称过滤 */
  get displayGoodsList (): ShopGoodsInfoDto[] {
    const kw = this.appliedKeyword.trim()
    if (!kw) return this.goodsList
    return this.goodsList.filter(g => (g.goodsName || '').includes(kw))
  }

  isGoodsDisabled (goodsId: string): boolean {
    return this.disabledGoodsIds.includes(goodsId)
  }

  get category2List () {
    const obj = {
      categoryId: '1',
      categoryName: '全部',
      children: [],
      hierarchyId: this.getHierarchyId(this.tabs[this.tabActive].hierarchyId)
    }
    return this.tabs[this.tabActive].children && [obj, ...this.tabs[this.tabActive].children] || []
  }

  handleClickOverlay() {
    this.contentOverlayShow = false
  }

  categoryClick(index) {
    this.active1Key = index
    this.getCategory(index)
    this.show = false
  }

  popupClick() {
    this.contentOverlayShow = false
    this.show = true
  }

  onAddGoods (): void {
    this.$router.push({
      path: "/addGoodsAssociate",
      query: { from: "selectGoods" },
    });
  }

  created() {
    // 保活缓存，避免去新增/编辑商品往返时实例销毁导致勾选丢失
    this.$store.commit('addKeepAlive', 'SelectGoods')
    this.params.companyId = this.companyId
    this.initPreselectedGoods()
    this.init()
    this.getStoreLevelManageList()
  }

  mounted () {
    this.$addScrollListener('.scroll-container')
  }

  activated() {
    window.localStorage.getItem('modifyPriceIndex')
    if (parseInt(window.localStorage.getItem('modifyPriceIndex')) > -1) {
      this.getModifyGoodsInfo('', parseInt(window.localStorage.getItem('modifyPriceIndex')))
      window.localStorage.setItem('modifyPriceIndex', '-1')
    }
    // 仅刷新列表；必须 remove 标记，否则后续每次 activated 都会重复刷新
    if (window.sessionStorage.getItem('jielongSelectGoodsRefresh')) {
      window.sessionStorage.removeItem('jielongSelectGoodsRefresh')
      this.onRefresh()
    }
    this.initPreselectedGoods()
    this.$setScrollY()
  }

  deactivated () {
    this.$removeScrollListener()
  }

  /** 去新增/编辑等子页时保留缓存；返回接龙页时清掉，避免下次进入残留旧勾选 */
  beforeRouteLeave (to, _from, next) {
    const preservePaths = ['/addGoods', '/addGoodsAssociate', '/MallSearchHistory']
    if (!preservePaths.some(p => to.path === p || to.path.startsWith(p + '/'))) {
      this.$store.commit('delKeepAlive', 'SelectGoods')
    }
    next()
  }

  async init() {
    await this.getPartnerCategoryList()
    this.params.hierarchyId = this.getHierarchyId(this.category.hierarchyId)
    this.getCyStoreGoodsList()
  }

  onRefresh() {
    this.refreshing = true
    this.getCyStoreGoodsList()
  }

  onLoad() {
    if (this.finished) {
      this.loading = false
      return
    }
    this.getCyStoreGoodsList()
  }

  dataInit() {
    this.goodsList = []
    this.finished = false
  }

  /** 商品名称前端搜索（输入即触发）：仅过滤当前最小分类已加载的商品 */
  onSearch() {
    this.appliedKeyword = this.searchValue.trim()
    this.syncCheckAll()
  }

  /** 从新建接龙页进入时，回显已在接龙商品列表中的商品并禁选 */
  initPreselectedGoods () {
    const raw = window.localStorage.getItem(PRESELECTED_GOODS_CACHE_KEY)
    if (raw === null) return
    window.localStorage.removeItem(PRESELECTED_GOODS_CACHE_KEY)
    try {
      const list: Array<{ goodsId: string }> = JSON.parse(raw) || []
      const ids = list.map(item => item.goodsId).filter(Boolean)
      this.disabledGoodsIds = ids
      this.selectedGoods = list.filter(item => item.goodsId)
    } catch (e) {
      this.disabledGoodsIds = []
      this.selectedGoods = []
    }
    this.upgradeSelectedGoodsFromList()
    this.syncCheckAll()
  }

  /** 列表加载后，用完整商品信息替换仅含 goodsId 的占位项 */
  upgradeSelectedGoodsFromList () {
    this.goodsList.forEach(goods => {
      const idx = this.selectedGoods.findIndex(s => s.goodsId === goods.goodsId)
      if (idx >= 0) {
        this.$set(this.selectedGoods, idx, goods)
      }
    })
  }

  /** 确认选择：仅把新选商品写入本地缓存并返回新建接龙页，由其 activated 钩子读取填充 */
  onConfirmSelect() {
    const newSelections = this.selectedGoods
      .filter(g => !this.disabledGoodsIds.includes(g.goodsId))
      .map(g => {
        const { storeImageList, ...rest } = g as ShopGoodsInfoDto & { storeImageList?: any[]; imgList?: any[] }
        return {
          ...rest,
          // 选品接口字段 storeImageList → 接龙侧统一用 imgList
          imgList: storeImageList ?? (g as any).imgList ?? [],
        }
      })
    window.localStorage.setItem('jielongSelectedGoods', JSON.stringify(newSelections))
    this.$store.commit('delKeepAlive', 'SelectGoods')
    this.$router.back()
  }

  resetData () {
    this.checkAll = false
    this.checkAllValue = false
    this.packageIdList = []
  }

  /** 全选 / 取消全选当前展示列表（已禁选商品不受影响；搜索时仅作用于过滤结果） */
  checkAllChange(checked: boolean) {
    this.checkAll = checked
    if (checked) {
      this.displayGoodsList.forEach(goods => {
        if (this.isGoodsDisabled(goods.goodsId)) return
        const exists = this.selectedGoods.some(g => g.goodsId === goods.goodsId)
        if (!exists) this.selectedGoods.push(goods)
      })
    } else {
      const currentIds = new Set(
        this.displayGoodsList
          .filter(g => !this.isGoodsDisabled(g.goodsId))
          .map(g => g.goodsId)
      )
      this.selectedGoods = this.selectedGoods.filter(g => !currentIds.has(g.goodsId))
    }
  }

  /** 单条商品勾选变化 */
  onGoodsChange(item: ShopGoodsInfoDto, checked: boolean) {
    if (this.isGoodsDisabled(item.goodsId)) return
    if (checked) {
      const exists = this.selectedGoods.some(g => g.goodsId === item.goodsId)
      if (!exists) this.selectedGoods.push(item)
    } else {
      this.selectedGoods = this.selectedGoods.filter(g => g.goodsId !== item.goodsId)
    }
    this.syncCheckAll()
  }

  /** 根据当前展示列表与 selectedGoods 同步全选状态（不含已禁选商品） */
  syncCheckAll() {
    const selectableGoods = this.displayGoodsList.filter(g => !this.isGoodsDisabled(g.goodsId))
    this.checkAll =
      selectableGoods.length > 0 &&
      selectableGoods.every(g => this.selectedGoods.some(s => s.goodsId === g.goodsId))
  }

  /**
   * 去历史记录页
   */
  toHistory() {
    this.$router.push({
      path: '/MallSearchHistory',
      query: {
        searchType: '1'
      }
    })
  }

  /**
   * 获取商品列表
   * @param {boolean} dataInit 是否初始化数据
   */
  async getCyStoreGoodsList (dataInit = false) {
    dataInit && this.dataInit()
    const { hierarchyId, companyId } = this.params
    getGoodsFileList({
      hierarchyId,
      companyId,
      categoryId: hierarchyId,
      storeId: companyId,
      queryType: 3,
      categoryType: 2
    })
      .then((res) => {
        const payload = res && res.data
        const records = Array.isArray(payload)
          ? payload
          : (payload && (payload.records || payload.list)) || []

        if (this.refreshing) {
          this.resetData()
        }
        this.goodsList = records
        this.upgradeSelectedGoodsFromList()
        this.finished = true
        this.syncCheckAll()
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
      })
  }

  filterCategoryList(list: Array<any>) {
    return list.filter((item) => {
      if (item.children) {
        item.children = this.filterCategoryList(item.children)
      }
      return Number(item.goodsCount) !== 0
    })
  }

  /**
   * 获取合作方下产业商城分类-新
   */
  async getPartnerCategoryList() {
    try {
      let res = await getGoodsFileCategory({ storeId: this.companyId, queryType: 1, isTree: 1 })
      // let res = await getPcGoodsCategoryList({
      //   isPage: false,
      //   pageIndex: 1,
      //   pageSize: 10000,
      //   categoryLevel: 0,
      //   storeId: this.companyId
      // })
      const allObj = {
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: ''
      }
      this.tabs = [allObj, ...this.filterCategoryList(res.data)]
      console.log('this.tabs ***', this.tabs)
      this.category = this.tabs[0]

      if (this.category.children && this.category.children[0]) {
        // 筛选三级分类a
        this.category3List =
          this.category.children[0].children &&
          this.category.children[0].children.map((item) => item)
        this.category3List && this.category3List.unshift({
          categoryId: '1',
          categoryName: '全部',
          hierarchyId: this.getHierarchyId(this.category.children[0].hierarchyId)
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 一级分类点击
  getCategory(index: number) {
    // if (this.active === index) return false
    this.category = this.tabs[index]

    // this.active = index
    this.tabActive = index
    this.active2Key = 0
    this.active3Key = 0
    // 一级切换每次都请求第一个二级分类
    if (this.category.children && this.category.children.length) {
      this.params.hierarchyId = this.getHierarchyId(this.category2List[0].hierarchyId)
    } else {
      this.params.hierarchyId = this.getHierarchyId(this.category.hierarchyId)
    }
    this.category3List = []
    if (this.category.children && this.category2List[0] && this.category2List[0].children && this.category2List[0].children.length) {
      // 筛选三级级分类
      // @ts-ignore
      this.category3List = this.category2List[0].children.map((item) => item)
      this.category3List.unshift({
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: this.getHierarchyId(this.category2List[0].hierarchyId)
      })
    }
    this.getCyStoreGoodsList(true)
  }

  // 二级分类点击
  getCategory2(index: number) {
    // if (this.activeKey === index) return false
    this.active2Key = index
    this.active3Key = 0

    this.params.hierarchyId = this.getHierarchyId(this.category2List[index].hierarchyId)
    this.category3List = []
    // @ts-ignore
    if (this.category2List.length && this.category2List[index].children && this.category2List[index].children.length) {
      // 筛选三级分类
      // @ts-ignore
      this.category3List = this.category2List[index].children && this.category2List[index].children.map((item) => item)
      this.category3List.unshift({
        categoryId: '1',
        categoryName: '全部',
        hierarchyId: this.getHierarchyId(this.category2List[index].hierarchyId)
      })
    }

    this.getCyStoreGoodsList(true)
  }

  handle3Category(item, index) {
    // if (this.active3Key === index) return
    this.active3Key = index
    this.params.hierarchyId = this.getHierarchyId(item.hierarchyId)
    this.getCyStoreGoodsList(true)
    this.contentOverlayShow = false
  }

  getHierarchyId (id: string) {
    if (id) {
      const arr = id.split('.')
      return arr[arr.length - 1]
    }
    return ''
  }

  handlePackageList (ids: Array<string>, isAdd = false) {
    ids.forEach(id => {
      const targetIndex = this.packageIdList.findIndex(packageId => packageId === id)
      if (isAdd) {
        if (targetIndex === -1) this.packageIdList.push(id)
      } else {
        if (targetIndex > -1) this.packageIdList.splice(targetIndex, 1)
      }
    })
    console.log('handlePackageList ***', this.packageIdList)
  }

  upShelves () {
    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: 1
    }).then(() => {
      this.$toast('上架成功')
      this.onRefresh()
    })
  }

  downShelves () {
    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: 2
    }).then(() => {
      this.$toast('下架成功')
      this.onRefresh()
    })
  }

  getStoreLevelManageList () {
    const params = {
      storeId: this.companyId,
      isPage: 1,
      pageIndex: 1,
      pageSize: 1000
    }
    getStoreLevelManageList(params).then(res => {
      this.levelList = res.data.records.map(item => {
        item.finalPriceCopy = this.specsValue * item.buyDiscount
        item.finalPrice = this.specsValue * item.buyDiscount
        item.buyDiscount = (item.buyDiscount * 100).toFixed()
        item.buyDiscountCopy = item.buyDiscount
        item.buySubtract = ''
        item.buySubtractCopy = item.buySubtract
        return { ...item }
      })
    })
  }

  changeVal (specsValue: number) {
    // @ts-ignore
    // this.specsValue = this.specsValue.replace(/[^\d.]/g, '')
    this.specsValue = specsValue
    this.levelList = this.levelList.map(item => {
      if (item.buyDiscountCopy) {
        item.finalPriceCopy = this.specsValue * item.buyDiscountCopy / 100 + ''
      }
      if (item.buySubtractCopy) {
        item.finalPriceCopy = ((this.specsValue * 1000) - (item.buySubtractCopy * 1000)) / 1000 + ''
      }
      item.finalPrice = this.specsValue * item.buyDiscount
      return { ...item }
    })
  }

  // blurVal (packageId: string, idx: number) {
  //   let flag = true
  //   let levelPriceList = this.levelList.map(item => {
  //     if (Number(this.specsValue) === Number(item.buySubtractCopy)) {
  //       flag = false
  //     }
  //     if (item.finalPriceCopy <= 0) {
  //       flag = false
  //     }

  //     return {
  //       levelId: item.levelId,
  //       packageId,
  //       buyDiscount: item.buyDiscountCopy && item.buyDiscountCopy / 100,
  //       buySubtract: item.buySubtractCopy
  //     }
  //   })
  //   if (!flag) {
  //     this.$toast({
  //       message: '价格修改失败\n(存在优惠后小于等于0元的商品套餐)',
  //       icon: 'close',
  //       className: 'customize-toast'
  //     })
  //     return false
  //   }
  //   modifyGoodsPriceSubmit({
  //     packageId,
  //     marketPrice: this.specsValue,
  //     // levelPriceList
  //   }).then(res => {
  //     this.$toast({
  //       message: '价格修改成功\n(差异定价同步更新)',
  //       icon: 'passed',
  //       className: 'customize-toast'
  //     })
  //     // this.onRefresh()
  //     this.getModifyGoodsInfo(packageId, idx)
  //   })
  // }

  // 获取修改价格的商品信息
  getModifyGoodsInfo (packageId: string, index: number) {
    const { hierarchyId, companyId } = this.params
    const goodsId = this.goodsList[index]?.goodsId
    getGoodsFileList({
      hierarchyId,
      companyId,
      categoryId: hierarchyId,
      storeId: companyId,
      queryType: 3,
      categoryType: 2,
      packageStatus: this.flag
    })
      .then((res) => {
        const payload = res && res.data
        const records = Array.isArray(payload)
          ? payload
          : (payload && (payload.records || payload.list)) || []
        const updated = records.find(item => item.goodsId === goodsId)
        if (updated) {
          this.$set(this.goodsList[index], 'goodsPackageList', updated.goodsPackageList)
        }
      })
  }
}
